import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import MembershipStatusChip from 'components/shared/chips/MembershipStatusChip';
import StyledClientOptionChip from 'common/theme/chips/StyledClientOptionChip';

function ClientOption({ option, props }) {
  const { t } = useTranslation(['sessions']);
  const {
    available_sessions: availableSessions,
    personalized_sessions: personalizedSessions,
    gender,
    label,
    membership_status: membershipStatus
  } = option;

  const sessionCount = availableSessions > 0 ? availableSessions : (personalizedSessions ?? 0);

  return (
    <Box component="li" {...props}>
      <Typography sx={{ marginRight: (theme) => theme.spacing(2) }}>{label}</Typography>
      <MembershipStatusChip context={gender?.toLowerCase() || 'other'} status={membershipStatus} />
      <StyledClientOptionChip
        label={`${sessionCount} ${t('availableSessions', { ns: 'sessions' })}`}
      />
    </Box>
  );
}

ClientOption.propTypes = {
  option: PropTypes.object.isRequired,
  props: PropTypes.object.isRequired
};

export default ClientOption;
